import React, { useEffect, useLayoutEffect } from 'react';
import InplayEventsTable from '../../components/ExchEventsTable/ExchInplayEventsTable';
import {
  clearAllEvents,
  clearExchcngeBets,
  fetchInplayEvents,
  fetchCountCategoryEvents,
} from '../../store';
import { connect } from 'react-redux';
import InplayImg from '../../assets/images/sportsbook/icons/inplay.svg';
import {
  connectToWS,
  isConnected,
  unsubscribeAllWsforEvents,
} from '../../webSocket/webSocket';
import './ExchInplayEventsView.scss';
import ExchangeSportsIconList from '../../components/ExchSportsListNav/ExchangeSportsIconList';
import { RootState } from '../../models/RootState';

type StoreProps = {
  clearAllEvents: () => void;
  clearExchcngeBets: () => void;
  fetchInplayEvents: () => void;
  fetchCountCategoryEvents: () => void;
  loggedIn: boolean;
  topicUrls: any;
};

const ExchInplayEventsView: React.FC<StoreProps> = (props) => {
  const {
    clearAllEvents,
    clearExchcngeBets,
    fetchInplayEvents,
    loggedIn,
    fetchCountCategoryEvents,
    topicUrls
  } = props;

  const updateEvents = () => {
    fetchInplayEvents();
    fetchCountCategoryEvents();
  };

  useEffect(() => {
    clearAllEvents();
    clearExchcngeBets();
  }, []);

  useLayoutEffect(() => {
    updateEvents();
  }, [loggedIn]);

  // Websocket handler
  // useEffect(() => {
  //   if (loggedIn && topicUrls?.matchOddsBaseUrl) {
  //     const baseUrlsPayload = {
  //       matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
  //       bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
  //       premiumBaseUrl: topicUrls?.premiumBaseUrl
  //     }
  //     connectToWS(baseUrlsPayload);
  //   }
  //   return () => {
  //     if (isConnected()) {
  //       unsubscribeAllWsforEvents();
  //     }
  //   };
  // }, [loggedIn, topicUrls]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      updateEvents();
    }, 10 * 1000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, []);

  useEffect(() => {
    document.getElementsByClassName('router-ctn')[0].scrollIntoView();
  }, []);

  return (
    <div className="exch-inplay-events-view">
      <div className="inplay-events-table-section">
        <div className="card">
          <div className="carw">
            <div className="arrow arrow-right">
              <div className="img-ctn">
                <img
                  src={InplayImg}
                  className="icon"
                  alt="inPlay"
                  height={25}
                  width={25}
                />
              </div>
              Inplay Events
            </div>
          </div>
          <ExchangeSportsIconList />
          <InplayEventsTable />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    topicUrls: state?.exchangeSports?.topicUrls,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    clearAllEvents: () => dispatch(clearAllEvents()),
    clearExchcngeBets: () => dispatch(clearExchcngeBets()),
    fetchInplayEvents: () => dispatch(fetchInplayEvents()),
    fetchCountCategoryEvents: () => dispatch(fetchCountCategoryEvents()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchInplayEventsView);
